import { ANALYTICS_SUBJECT_ID_APP_DOCUMENTATION_LINK, ANALYTICS_SUBJECT_ID_APP_FORUMS_LINK, ANALYTICS_SUBJECT_ID_APP_ISSUE_TRACKER_LINK, ANALYTICS_SUBJECT_ID_APP_STATUS_PAGE_LINK, ANALYTICS_SUBJECT_ID_COMMUNITY_QUESTION_LINK, EVENT_CONTAINER_SUPPORT_APPLISTING_TAB, LinkClickedEvent, useAnalyticsEvents } from '@atlassian/mpac-analytics';
import { ExternalLink, H6 } from '@atlassian/mpac-primitives';
import * as React from 'react';
import { SupportResourcesLink } from '../../types';
import { ResourceListItem, ResourceSubTitle } from './styles';
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
export const DocumentationResource = props => {
  const {
    documentationUrl,
    onSupportLinkClick
  } = props;
  const fireAnalyticsEvent = useAnalyticsEvents();
  return /*#__PURE__*/_jsx(_Fragment, {
    children: documentationUrl && /*#__PURE__*/_jsxs(ResourceListItem, {
      children: [/*#__PURE__*/_jsx(H6, {
        as: "h4",
        children: "App documentation"
      }), /*#__PURE__*/_jsxs(ResourceSubTitle, {
        children: ["Comprehensive set of documentation from the partner on", ' ', /*#__PURE__*/_jsx(ExternalLink, {
          href: documentationUrl,
          size: "medium",
          onClick: () => {
            fireAnalyticsEvent({
              eventType: LinkClickedEvent,
              actionSubjectId: ANALYTICS_SUBJECT_ID_APP_DOCUMENTATION_LINK,
              eventContainer: EVENT_CONTAINER_SUPPORT_APPLISTING_TAB,
              attributes: {
                linkText: 'how this app works'
              }
            });
            onSupportLinkClick(SupportResourcesLink.DOCUMENTATION);
          },
          children: "how this app works"
        }), "."]
      })]
    })
  });
};
export const ForumsResource = props => {
  const fireAnalyticsEvent = useAnalyticsEvents();
  const {
    forumsUrl,
    onSupportLinkClick
  } = props;
  return /*#__PURE__*/_jsx(_Fragment, {
    children: forumsUrl && /*#__PURE__*/_jsxs(ResourceListItem, {
      children: [/*#__PURE__*/_jsx(H6, {
        as: "h4",
        children: "Forum"
      }), /*#__PURE__*/_jsxs(ResourceSubTitle, {
        children: [/*#__PURE__*/_jsx(ExternalLink, {
          href: forumsUrl,
          size: "medium",
          onClick: () => {
            fireAnalyticsEvent({
              eventType: LinkClickedEvent,
              actionSubjectId: ANALYTICS_SUBJECT_ID_APP_FORUMS_LINK,
              eventContainer: EVENT_CONTAINER_SUPPORT_APPLISTING_TAB,
              attributes: {
                linkText: 'Explore external community discussions'
              }
            });
            onSupportLinkClick(SupportResourcesLink.COMMUNITY);
          },
          children: "Explore external community discussions"
        }), ' ', "that connect you to the Marketplace partner and other customers who use this app."]
      })]
    })
  });
};
export const AtlassianCommunityResource = props => {
  const fireAnalyticsEvent = useAnalyticsEvents();
  const {
    atlassianCommunityUrl,
    onSupportLinkClick
  } = props;
  return /*#__PURE__*/_jsxs(ResourceListItem, {
    children: [/*#__PURE__*/_jsx(H6, {
      as: "h4",
      children: "Atlassian Community"
    }), /*#__PURE__*/_jsxs(ResourceSubTitle, {
      children: [/*#__PURE__*/_jsx(ExternalLink, {
        href: atlassianCommunityUrl,
        size: "medium",
        onClick: () => {
          fireAnalyticsEvent({
            eventType: LinkClickedEvent,
            actionSubjectId: ANALYTICS_SUBJECT_ID_COMMUNITY_QUESTION_LINK,
            eventContainer: EVENT_CONTAINER_SUPPORT_APPLISTING_TAB,
            attributes: {
              linkText: 'Engage with Atlassian-hosted discussions'
            }
          });
          onSupportLinkClick(SupportResourcesLink.ATLASSIAN_COMMUNITY);
        },
        children: "Engage with Atlassian-hosted discussions"
      }), ' ', "where other customers discuss about apps."]
    })]
  });
};
export const StatusPageResource = props => {
  const fireAnalyticsEvent = useAnalyticsEvents();
  const {
    statusPageUrl,
    onSupportLinkClick
  } = props;
  return /*#__PURE__*/_jsx(_Fragment, {
    children: statusPageUrl && /*#__PURE__*/_jsxs(ResourceListItem, {
      children: [/*#__PURE__*/_jsx(H6, {
        as: "h4",
        children: "Status page"
      }), /*#__PURE__*/_jsxs(ResourceSubTitle, {
        children: [/*#__PURE__*/_jsx(ExternalLink, {
          href: statusPageUrl,
          size: "medium",
          onClick: () => {
            fireAnalyticsEvent({
              eventType: LinkClickedEvent,
              actionSubjectId: ANALYTICS_SUBJECT_ID_APP_STATUS_PAGE_LINK,
              eventContainer: EVENT_CONTAINER_SUPPORT_APPLISTING_TAB,
              attributes: {
                linkText: 'Visit the partner status page'
              }
            });
            onSupportLinkClick(SupportResourcesLink.STATUS_PAGE);
          },
          children: "Visit the partner status page"
        }), ' ', "to get updates on incidents or uptime."]
      })]
    })
  });
};
export const IssueTrackerResource = props => {
  const fireAnalyticsEvent = useAnalyticsEvents();
  const {
    issueTrackerUrl,
    onSupportLinkClick,
    enableIssueTerminology
  } = props;
  return /*#__PURE__*/_jsx(_Fragment, {
    children: issueTrackerUrl && /*#__PURE__*/_jsxs(ResourceListItem, {
      children: [/*#__PURE__*/_jsx(H6, {
        as: "h4",
        children: enableIssueTerminology ? 'Track work items' : 'Issue tracker'
      }), /*#__PURE__*/_jsxs(ResourceSubTitle, {
        children: [/*#__PURE__*/_jsx(ExternalLink, {
          href: issueTrackerUrl,
          size: "medium",
          onClick: () => {
            fireAnalyticsEvent({
              eventType: LinkClickedEvent,
              actionSubjectId: ANALYTICS_SUBJECT_ID_APP_ISSUE_TRACKER_LINK,
              eventContainer: EVENT_CONTAINER_SUPPORT_APPLISTING_TAB,
              attributes: {
                linkText: 'Visit the issue tracker page'
              }
            });
            onSupportLinkClick(SupportResourcesLink.ISSUE_TRACKER);
          },
          children: enableIssueTerminology ? 'Visit the tracker page' : 'Visit the issue tracker page'
        }), ' ', "to view existing bug reports and feature requests for this app."]
      })]
    })
  });
};